import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss']
})
export class MapViewComponent implements OnInit {

  constructor() { }
  map : google.maps.Map | undefined ;
  lat=12.900342
  lng=77.790047
  coordinates = new google.maps.LatLng(this.lat, this.lng);
  mapOptions: google.maps.MapOptions =
  {
      center:this.coordinates,
      zoom: 12,
      mapTypeControl: false,
      streetViewControl: false,
  };
  ngOnInit(): void {
  }
  ngAfterViewInit()
  {
    this.mapInitializer()
  }

   mapInitializer()
  {

    this.map = new google.maps.Map(document.getElementById("map") as HTMLElement,this.mapOptions);
  
  }
}
